/* Vanilla Tweaks panel — host edit-mode protocol, wired to window.SALON.setTweak */
(function(){
"use strict";
const DEFAULTS={ chrome:'vault', accent:'#2962FF', sound:true };
const LS='salon_tweaks';
let T=Object.assign({},DEFAULTS);
try{ const r=JSON.parse(localStorage.getItem(LS)); if(r) T=Object.assign({},DEFAULTS,r);}catch(e){}

const ACCENTS=[
  {n:'Electric',v:'#2962FF'},
  {n:'Bloom',v:'#FF4D8D'},
  {n:'Mint',v:'#1FB479'},
  {n:'Amber',v:'#F5A300'},
  {n:'Ink',v:'#0D0D0D'}
];

function apply(){
  // map to SALON
  if(window.SALON){
    window.SALON.setTweak('chromeDay', T.chrome==='day');
    window.SALON.setTweak('accent', T.accent);
    window.SALON.setTweak('sound', T.sound);
  }
}
function persist(){
  try{ localStorage.setItem(LS,JSON.stringify(T)); }catch(e){}
  // host persistence
  try{ window.parent.postMessage({type:'__edit_mode_set_keys',edits:{tweaks:T}},'*'); }catch(e){}
}

let panel;
function build(){
  panel=document.createElement('div'); panel.className='tweaks-panel'; panel.style.display='none';
  panel.innerHTML=`
    <div class="tw-h"><span class="tw-title">Tweaks</span><button class="tw-x" title="Close">&times;</button></div>
    <div class="tw-body">
      <div class="tw-sec">Chrome</div>
      <div class="tw-seg" data-key="chrome">
        <button data-v="vault">Vault</button><button data-v="day">Daylight</button>
      </div>
      <div class="tw-sec">Accent</div>
      <div class="tw-sw" data-key="accent">
        ${ACCENTS.map(a=>`<button data-v="${a.v}" title="${a.n}" style="background:${a.v}"></button>`).join('')}
      </div>
      <div class="tw-sec">Sound</div>
      <div class="tw-tog" data-key="sound"><span class="tw-knob"></span><span class="tw-lab">Room ambience &amp; notes</span></div>
      <div class="tw-foot">11 rooms · 111 works · on-chain provenance</div>
    </div>`;
  document.body.appendChild(panel);
  // segmented
  panel.querySelector('.tw-seg').addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;T.chrome=b.dataset.v;sync();apply();persist();});
  panel.querySelector('.tw-sw').addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;T.accent=b.dataset.v;sync();apply();persist();});
  panel.querySelector('.tw-tog').addEventListener('click',()=>{T.sound=!T.sound;sync();apply();persist();});
  panel.querySelector('.tw-x').addEventListener('click',dismiss);
  sync();
}
function sync(){
  if(!panel)return;
  panel.querySelectorAll('.tw-seg button').forEach(b=>b.classList.toggle('on',b.dataset.v===T.chrome));
  panel.querySelectorAll('.tw-sw button').forEach(b=>{b.classList.toggle('on',b.dataset.v===T.accent);b.style.setProperty('--ac',T.accent);});
  panel.querySelector('.tw-tog').classList.toggle('on',T.sound);
}

function open(){ panel.style.display='block'; void panel.offsetWidth; panel.classList.add('show'); }
function close(){ panel.classList.remove('show'); setTimeout(()=>panel.style.display='none',240); }
function dismiss(){ close(); try{window.parent.postMessage({type:'__edit_mode_dismissed'},'*');}catch(e){} }

window.addEventListener('message',e=>{
  const t=e&&e.data&&e.data.type;
  if(t==='__activate_edit_mode') open();
  else if(t==='__deactivate_edit_mode') close();
});

function boot(){
  build(); apply();
  try{ window.parent.postMessage({type:'__edit_mode_available'},'*'); }catch(e){}
}
if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();